import { SERVER_API_URL } from './public-api-url';

export const DIRECT_BACKEND_API_URL = SERVER_API_URL;

interface CreateDirectBackendHeadersParams {
  accessToken?: string;
  hasJsonContentType?: boolean;
}

export function buildDirectBackendUrl(path: string): string {
  return new URL(path, DIRECT_BACKEND_API_URL).toString();
}

export function createDirectBackendHeaders({
  accessToken,
  hasJsonContentType = false,
}: CreateDirectBackendHeadersParams): HeadersInit {
  const headers: Record<string, string> = {};

  if (hasJsonContentType) {
    headers['Content-Type'] = 'application/json';
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return headers;
}
